import {DOCUMENT} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {UserI} from '../interfaces/user.interface';
import {AppService} from '../services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  // styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public context: string;
  public title = 'sso-client';
  public authed = false;
  public user: UserI;
  public sideNavActive = false;

  constructor(
    public app: AppService,
    public router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {

  }

  protected init(): void {
    this.app.context = this.context;
    this.app.isAuthed((auth: boolean) => {
      this.authed = auth;
      this.user = this.app.user;
    });

    this.loadStyle();
  }

  private loadStyle(): void {
    const head = this.document.getElementsByTagName('head')[0];

    const style = this.document.createElement('link');
    style.id = this.context;
    style.rel = 'stylesheet';
    style.href = this.context + '.css';

    head.appendChild(style);
  }

  public logout(): void {
    this.app.logout();
  }

  public newPassword(): void {
    this.app.dialog.loader({title: 'Fordere neue Passwort an'});
    this.app.lostPassword(this.user.email).then(() => {
      setTimeout(() => {
        this.app.dialog.closeLoader();
        this.app.router.navigateByUrl('neues-passwort/angefordert', {
          params: {
            type: 'PW_REQUEST',
            returnType: 'WELCOME',
            email: this.user.email
          }
        });
      }, 500);
    });
  }
}
